var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ xmlns: "http://www.w3.org/2000/svg", width: "10", height: "16", viewBox: "0 0 10 16" }, props),
    React.createElement("path", { fillRule: "evenodd", d: "M2.237 6.322a.75.75 0 0 1 0-1.095.838.838 0 0 1 1.147 0l3.379 3.226a.75.75 0 0 1 0 1.094l-3.379 3.226a.838.838 0 0 1-1.147 0 .75.75 0 0 1 0-1.095L5.043 9 2.237 6.322z" })
  );
});